import { ItemElement, PlatformItem } from './common.types';
//---------------------------------
//-------------ENUMS---------------
//---------------------------------

export enum ProjectTechnology {
  HTML = 'html',
  CSS = 'css',
  JAVASCRIPT = 'javascript',
  TYPESCRIPT = 'typescript',
  REACT = 'react',
  REACT_NATIVE = 'reactnative',
  SCSS = 'scss',
  NEXT_JS = 'nextjs',
}

export enum ProjectTool {
  GIT = 'git',
  JIRA = 'jira',
  CONFLUENCE = 'confluence',
  PHOTOSHOP = 'photoshop',
  EXPO = 'expo',
  VITE = 'vite',
  // FIGMA = 'figma',
}

export enum ProjectFunction {
  PLANNED = 'planned',
  DESIGNED = 'designed',
  DEVELOPED = 'developed',
  IMPLEMENTED = 'implemented',
  OPTIMIZED = 'optimized',
  DEPLOYED = 'deployed',
}

export enum ProjectType {
  ACADEMICAL = 'Academical',
  FREELANCE = 'Freelance',
  PROFESSIONAL = 'Professional',
}

//---------------------------------
//------------TYPES----------------
//---------------------------------

export type TechnologyItem = ItemElement & {
  name: ProjectTechnology | string;
};

export type ToolItem = ItemElement & {
  name: ProjectTool;
};

export type FunctionItem = ItemElement & {
  name: ProjectFunction;
  labelEn?: string;
  labelPt?: string;
  descEn?: string;
  descPt?: string;
};

export type ProjectTypeItem = {
  name: ProjectType;
  labelEn: string;
  labelPt: string;
};

export type ProjectItem = {
  id: string | number;
  name: string;
  descEn: string;
  descPt: string;
  aboutEn: string;
  aboutPt: string;
  client?: string;
  platforms: [PlatformItem, ...PlatformItem[]];
  img?: string;
  logo?: string;
  video?: string;
  startBackgroundColor?: boolean;
  backgroundColor: string;
  font?: string;
  url?: string | null | undefined;
  preview?: string;
  type: ProjectType;
  year: number;
  technologies: [TechnologyItem, ...TechnologyItem[]];
  tools?: [ToolItem, ...ToolItem[]];
  functions: [FunctionItem, ...FunctionItem[]];
};
